"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Vpncomparisonprotocol() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: tableRef,
    isVisible: tableVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const rows = [{
    attribute: "Encryption",
    consumer: "Standard AES",
    ridge: "Military-grade 256"
  }, {
    attribute: "Speed",
    consumer: "Variable",
    ridge: "Ultra-fast 10Gbps"
  }, {
    attribute: "Privacy",
    consumer: "Logs kept",
    ridge: "Zero-log policy"
  }, {
    attribute: "Servers",
    consumer: "Limited",
    ridge: "Global 5000+ nodes"
  }, {
    attribute: "Support",
    consumer: "Email only",
    ridge: "24/7 Live Chat"
  }, {
    attribute: "Interface",
    consumer: "Cluttered",
    ridge: "Minimalist UI"
  }, {
    attribute: "Uptime",
    consumer: "99.0%",
    ridge: "99.999%"
  }];
  return <section data-section-id="4671" id="vpncomparisonprotocol" className="bg-background text-foreground py-24 md:py-36 lg:py-44 px-6 md:px-10 lg:px-16">
      <div className="mx-auto max-w-7xl">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-8">
            <p className="font-default text-xs md:text-[13px] uppercase tracking-[0.2em] font-medium mb-8 md:mb-10" style={{
            color: "var(--foreground)"
          }}>
              — VPNGENIX ADVANTAGE
            </p>
            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl xl:text-[80px] leading-[0.95] tracking-tight">
              Why the difference{" "}
              <span className="block md:inline">
                <span className="font-serif italic font-normal">matters.</span>
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:pt-4">
            <p className="font-serif text-lg md:text-[18px] leading-relaxed max-w-md" style={{
            color: "var(--foreground)",
            opacity: 0.7
          }}>
              Generic VPNs are built for mass markets. VPNGENIX is engineered for total digital privacy.
            </p>
          </div>
        </div>

        {}
        <div ref={tableRef} className={`mt-20 md:mt-24 lg:mt-28 transition-all duration-1000 ease-out delay-200 ${tableVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden md:block">
            {}
            <div className="grid grid-cols-12 h-20 items-end pb-5 border-b border-border">
              <div className="col-span-3 px-4">
                <p className="font-default text-[13px] uppercase tracking-[0.2em] font-medium" style={{
                color: "var(--foreground)"
              }}>
                  Feature
                </p>
              </div>
              <div className="col-span-4 px-4">
                <p className="font-default text-[13px] uppercase tracking-[0.2em] font-medium" style={{
                color: "var(--foreground)"
              }}>
                  Standard VPN
                </p>
              </div>
              <div className="col-span-5 px-6 relative">
                <div className="absolute top-0 left-0 right-0 h-[3px]" style={{
                backgroundColor: "var(--primary)"
              }} />
                <p className="font-default text-[13px] uppercase tracking-[0.2em] font-medium pt-3" style={{
                color: "var(--foreground)"
              }}>
                  VPNGENIX
                </p>
              </div>
            </div>

            {}
            {rows.map((row, i) => <div data-index={i} key={i} className="grid grid-cols-12 min-h-[88px] items-center border-b" style={{
            borderColor: "var(--border)"
          }}>
                <div className="col-span-3 px-4 py-6">
                  <p className="font-serif text-base md:text-[16px]" style={{
                color: "var(--foreground)"
              }}>
                    {row.attribute}
                  </p>
                </div>
                <div className="col-span-4 px-4 py-6">
                  <p className="font-serif italic text-sm md:text-[14px]" style={{
                color: "var(--muted-foreground)"
              }}>
                    {row.consumer}
                  </p>
                </div>
                <div className="col-span-5 px-6 py-6 h-full flex items-center gap-3" style={{
              backgroundColor: "var(--accent)",
              opacity: 1
            }}>
                  <Check className="size-4 shrink-0" strokeWidth={2.5} style={{
                color: "var(--primary)"
              }} />
                  <p className="font-default text-base md:text-[16px] font-medium" style={{
                color: "var(--foreground)"
              }}>
                    {row.ridge}
                  </p>
                </div>
              </div>)}
          </div>

          {}
          <div className="md:hidden space-y-6">
            {rows.map((row, i) => <div data-index={i} key={i} className="border border-border">
                <div className="px-5 py-4 border-b border-border" style={{
              backgroundColor: "var(--card)"
            }}>
                  <p className="font-default text-[11px] uppercase tracking-[0.2em] font-medium mb-1" style={{
                color: "var(--muted-foreground)"
              }}>
                    Feature
                  </p>
                  <p className="font-serif text-xl text-foreground">{row.attribute}</p>
                </div>
                <div className="px-5 py-4 border-b border-border">
                  <p className="font-default text-[11px] uppercase tracking-[0.2em] font-medium mb-1" style={{
                color: "var(--muted-foreground)"
              }}>
                    Standard VPN
                  </p>
                  <p className="font-serif italic text-sm" style={{
                color: "var(--muted-foreground)"
              }}>
                    {row.consumer}
                  </p>
                </div>
                <div className="px-5 py-4 relative" style={{
              backgroundColor: "var(--accent)"
            }}>
                  <div className="absolute top-0 left-0 right-0 h-[3px]" style={{
                backgroundColor: "var(--primary)"
              }} />
                  <p className="font-default text-[11px] uppercase tracking-[0.2em] font-medium mb-2 pt-2" style={{
                color: "var(--foreground)"
              }}>
                    VPNGENIX
                  </p>
                  <div className="flex items-start gap-2">
                    <Check className="size-4 shrink-0 mt-1" strokeWidth={2.5} style={{
                  color: "var(--primary)"
                }} />
                    <p className="font-default text-base font-medium text-foreground">
                      {row.ridge}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}